// src/processors/style/style-file-handler.ts
import { XConVitePluginOptions } from '../../types';
import { fsUtils } from '../../utils/fs-utils';
import { Logger } from "../../utils/logger";

/**
 * Handles style file loading and path resolution
 */
export class StyleFileHandler {
    constructor(
        private options: Required<XConVitePluginOptions>,
        private logger: Logger
    ) {}

    /**
     * Load style file content with proper path resolution
     * Returns both content and full path for SASS compilation
     */
    loadStyleFile(
        stylePath: string,
        id: string,
        addWatchFile: (file: string) => void
    ): { content: string; fullPath: string } | null {
        const path = require('path');
        const tsFileDir = path.dirname(id);
        const fullStylePath = path.resolve(tsFileDir, stylePath);

        this.logger.debug(`  📂 Resolving style:`);
        this.logger.debug(`     Source file: ${id}`);
        this.logger.debug(`     Style ref: ${stylePath}`);
        this.logger.debug(`     Resolved to: ${fullStylePath}`);

        if (this.options.watchFiles && fsUtils.isNodeEnvironment()) {
            addWatchFile(fullStylePath);
        }

        if (!fsUtils.existsSync(fullStylePath)) {
            this.logger.warn(`❌ Style file not found: ${fullStylePath}`);
            this.logger.warn(`   Referenced as: ${stylePath}`);
            this.logger.warn(`   From file: ${id}`);
            return null;
        }

        try {
            const content = fsUtils.readFileSync(fullStylePath, 'utf8');
            const sizeKB = (content.length / 1024).toFixed(2);
            this.logger.debug(`  ✅ Style loaded: ${path.basename(fullStylePath)} (${sizeKB}KB)`);

            return {
                content,
                fullPath: fullStylePath
            };
        } catch (error) {
            this.logger.error(`❌ Failed to read style: ${fullStylePath}`, error);
            return null;
        }
    }
}